import { CSS } from '@grupoboticario/flora-react'

export const wrapperCss: CSS = {
  borderBottom: '1px solid $nonInteractiveAltAuxiliar',
  marginBottom: '$6',
  paddingBottom: '$1',
  width: '100%'
}
